import { render, staticRenderFns } from "./MotmPanel.vue?vue&type=template&id=6b9ef68d&"
import script from "./MotmPanel.vue?vue&type=script&lang=js&"
export * from "./MotmPanel.vue?vue&type=script&lang=js&"
import style0 from "./MotmPanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports